/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Common reducer for all Settings tabs
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { ISettingsCommonReducer, TSettingsCommonActionTypes } from './PageSettingsTypes';
import { SETTINGS_LOADER_START, SETTINGS_LOADER_STOP } from './settingsConstants';

export const initialSettingsCommonState: ISettingsCommonReducer = {
    isShowLoading: false,
}

export const settingsCommonReducer: Reducer<ISettingsCommonReducer, TSettingsCommonActionTypes> =
    (state: ISettingsCommonReducer = initialSettingsCommonState, action: TSettingsCommonActionTypes) =>
        produce(state, draft => {
            switch (action.type) {
                case SETTINGS_LOADER_START:
                    draft.isShowLoading = true;
                    break;
                case SETTINGS_LOADER_STOP:
                    draft.isShowLoading = false;
                    break;
                default:
                    break;
            }
        })
